<template>
    <div class="py-6">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ProcessTab",
        props: {
            step: String,
            title: String
        },
        mounted() {
            this.$parent.tabs.push({
                step: this.step,
                title: this.title
            })
        }
    }
</script>

<style scoped>

</style>